// extracted by mini-css-extract-plugin
module.exports = {"root":"DebuggerWindow_root__2KyI-","window":"DebuggerWindow_window__UlFlg"};